import RestClient from "@/api/utils/baseRestClient";
import { atmoClient } from "@/setup/clients/atmoClient";

export const parameterRestClient = new RestClient(atmoClient, "parameters");
